import {Box, Modal, Text} from "@nike/eds";
import {edsSpace16} from "@nike/eds/dist/tokens";
import RocketIcon from "../shared/rocket";

const BondedReturnTriggeredModal = ({
    isOpen, setIsOpen
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onDismiss={() => setIsOpen(false)}
            headerSlot="Bonded return increment triggered"
        >
            <Box>
                <Text>
                    Please note: processing the event(s) will take some time
                </Text>
                <div style={{marginTop: edsSpace16, textAlign: "center"}}>
                    <RocketIcon/>
                </div>
            </Box>
        </Modal>
    );
};

export default BondedReturnTriggeredModal;
